import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    InMemoryScrollingOptions,
    PreloadAllModules,
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';
import { headersInterceptor } from '@app/interceptor/headers-interceptor';
import { policyInterceptor } from '@app/interceptor/policy-interceptor';
import { screensPreviewInterceptor } from '@app/interceptor/screens-preview-interceptor';
import { tokenInterceptor } from '@app/interceptor/token-interceptor';
import { NoCacheTranslateLoader } from '@app/utils/no-cache-translate-loader';
import { provideKoneUI } from '@kone/ui';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { routes } from './app.routes';

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'disabled',
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withInMemoryScrolling(scrollConfig),
            withPreloading(PreloadAllModules),
        ),
        provideHttpClient(
            withXhr(),
            withInterceptors([
                screensPreviewInterceptor,
                policyInterceptor,
                tokenInterceptor,
                headersInterceptor,
            ]),
        ),
        provideAnimations(),
        provideKoneUI(),
        importProvidersFrom(
            TranslateModule.forRoot({
                defaultLanguage: 'en',
                loader: {
                    provide: TranslateLoader,
                    useFactory: () => new NoCacheTranslateLoader(),
                },
            }),
        ),
    ],
};
